import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { relatoriosGestaoSchema } from './schemas';

export function useRelatoriosGestao() {
  return useQuery({
    queryKey: ['relatorios-gestao'],
    queryFn: ({ signal }) => api('/api/v2/relatorios/gestao', { schema: relatoriosGestaoSchema, signal }),
    staleTime: 60_000,
  });
}
